import { CountryEnum } from "@vini-wine/core-enums";
import { VatTaxDto } from "@vini-wine/core-dtos";

export interface VatTaxModel {
  // transform
  value: string;
  countryCode: CountryEnum;
}

export const createVatTaxDtoFromAnalyticVatTaxModel = (
  vatTax: VatTaxModel,
): VatTaxDto => {
  return {
    countryCode: vatTax.countryCode,
    value: vatTax.value,
  };
};
